
import Vue from 'vue';

export default Vue.extend({
  name: 'ExpandableFragment',

  props: {
    icon: { type: String, required: true },
    expandable: { type: Boolean, default: true },
    expand: { type: Boolean, default: false },
  },

  watch: {
    expand(v) {
      this.expanded = v;
    },
    hover(_) {
      this.$emit('hover', this.hover);
    },
  },

  data() {
    return {
      expanded: this.expand,
      hover: false,
    };
  },

});
